module.exports = __webpack_public_path__ + "img/icon_map_61_off_111.853556dc.png";